export enum SessionTypes {
    oneToOne = 'oneToOne',
    oneToMany = 'oneToMany',
    positionAndImage = 'positionAndImage',
    full = 'full'
}
